import React from 'react'
import { connect } from 'react-redux'

import './index.css'

import {
    Row,
    Icon,
    Col,
    message
} from 'antd'

const SCALE_MIN = 0.5
const SCALE_MAX = 1.5

class CategoryFeatureDisplay extends React.Component {

    state = {
        scale: 1,
        active: false
    }

    render(){

        const { 
            fileList,
            styleSheet
        } = this.props.activeCategoryFeature

        if( !fileList ){
            return null
        }

        const mainFile = fileList.filter( _file => _file.className === "main")[0]

        return (
            <div>
                <div style={{marginBottom: 12}}>
                    {this.renderHelp()}
                </div>
                <Row 
                align="middle"
                type="flex"
                justify="space-between"
                >
                    <Col>
                        <span>
                            <h3>
                                Zoom: {this.state.scale.toFixed(1)}x
                            </h3>
                        </span>
                    </Col>
                    <Col>
                        <Icon
                        onClick={()=>this.setState({
                            scale: this.state.scale >= SCALE_MAX? this.state.scale: this.state.scale + 0.1
                        })}
                        className="zoom-icon"
                        type="zoom-in" />
                        <Icon
                        onClick={()=>this.setState({
                            scale: this.state.scale <= SCALE_MIN? this.state.scale: this.state.scale - 0.1
                        })}
                        className="zoom-icon"
                        type="zoom-out" />
                    </Col>
                </Row>
                <div 
                onClick={this.handleClick}
                className="scene-container">
                    <div 
                    style={{
                        transform: `scale(${this.state.scale})`,
                        backgroundImage: mainFile?`url("${mainFile.url}")`:''
                    }}
                    className="scene">
                        <style dangerouslySetInnerHTML={{__html: styleSheet}}/>
                        {fileList.filter( _file => _file.className !== "main" ).map( _file => {
                            return (
                                <div 
                                onMouseEnter={()=>this.setState({ active: _file.category && _file.category.titleUrl })}
                                onMouseLeave={()=>this.setState({ active: null})}
                                className={`${_file.className} ${ _file.category && (this.state.active === _file.category.titleUrl)?'active':''}`}>
                                    <img 
                                    src={_file.url}/>
                                    <div className="text">
                                        {_file.category && _file.category.title}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

    handleClick = (e) => {
        // e = Mouse click event.
        const rect = e.target.getBoundingClientRect();
        const x = (e.clientX - rect.left).toFixed(2); //x position within the element.
        const y = (e.clientY - rect.top).toFixed(2);  //y position within the element.

        this.copyToClipboard(`top: ${y}px;\nleft: ${x}px;`);

        message.success("Position copied to clipboard!")

    }

    copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };
      

    renderHelp = () => {
        return (
            <ul>
                <li>
                    Use <b>.active</b> to change the hover styling of each image
                </li>
                <li>
                    Use <b>.[className]</b> to change the styling of the container
                </li>
                <li>
                    Use <b>.[className] img</b> to change the styling of the image
                </li>
                <li>
                    Use <b>.[className] .text</b> to change the styling of the text
                </li>
            </ul>
        )
    }

   
}

export default connect(
    state => ({
        activeCategoryFeature: state.categoryFeatures.activeCategoryFeature
    })
)(CategoryFeatureDisplay)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/category-feature-display/index.js